import { Paged } from './Misc';
import { HighlightTooltip } from './Operation';

export enum Phase {
  Identification = 'Identification',
  Structuring = 'Structuring',
  Approval = 'Approval',
  Execution = 'Execution',
}

export enum Period {
  Week = 'WEEK',
  TwoWeeks = '2WEEKS',
  Month = 'MONTH',
}

export enum QueryUser {
  All = 'ALL',
  My = 'MY',
  MyGroup = 'GR',
  Grievance = 'GP',
}

export const Periods = [Period.Week, Period.TwoWeeks, Period.Month];

export interface DashboardFilter {
  ganttMode: boolean;
  period: Period;
  phase: Phase | null;
  periodRelative: number;
  memberUserId: number;
  pageNumber: number;
  pageSize: number;
  sortDescending: boolean;
  sortField: string;
}

export interface DashboardOverviewFilter {
  queryUser: string;
}

export interface Member {
  id: number;
  name: string;
}

export interface DashboardItem {
  id: number;
  title: string;
  operationId: number;
  operationNumber: string;
  startDate: string;
  dueDate: string | null;
  stage: string;
  status: string;
  statusText: string;
  safeguardPerformance: string;
  esrr: string;
  primaryMember: string;
  isOverdue: boolean;
  isExecution: boolean;
}

export type DashboardHighlightTooltip = HighlightTooltip<HighlightDataRow[]>;

export interface DashboardOverview {
  operationSummary: DashboardHighlightTooltip[];
  upcomingMilestones: DashboardHighlightTooltip[];
  pendingTasks: DashboardHighlightTooltip[];
  lastDocuments: DashboardDocumentInfo[];
  grievanceSummary: DashboardHighlightTooltip[];
  grievanceDocuments: DashboardDocumentInfo[];
  grievanceClosure: DashboardDocumentInfo[];
}

export interface HighlightDataRow {
  id: string;
  name: string;
  date: string;
}

export interface DashboardDocumentInfo {
  linkName: string;
  documentType: string;
  operationId: number;
  operationNumber: string;
}

export interface DashboardList extends Paged<DashboardItem> {
  periodText: string | null;
  firstPeriodDay: string;
  lastPeriodDay: string;
  operationsCounter: number;
  documentsEdit: number;
}
